<template>
  <h4 class="tw:font-bold tw:mt-6 tw:mb-1">{{ $t('business_studio_plus_checkout_payment_details_header') }}</h4>
  <div v-if="isFetching">
    <div class="tw:animate-pulse tw:bg-gray-300 tw:rounded tw:w-full tw:h-6" aria-hidden="true"></div>
  </div>
  <div v-else-if="isError" class="tw:text-red-700" v-html="$t('errors.wrong_data_from_app')" />
  <div v-else>
    <div v-if="defaultPaymentMethodType === 'CREDIT_CARD'" class="tw:inline">
      <img
        v-if="creditCardLogo"
        :src="creditCardLogo"
        alt="Credit card logo"
        height="24"
        width="38"
        class="shadow-[0_0_1px_0_rgba(41,52,58,0.75)] tw:mr-2 tw:inline"
      />
      <span>
        {{
          $t('paymentMethods.paymentMethod.creditCard', {
            mask: creditCardNumberMask,
            month: creditCardExpirationMonth,
            year: creditCardExpirationYear,
          })
        }}
        -&nbsp;
      </span>
      <span>{{ creditCardHolderName }}</span>
    </div>
    <div v-else-if="defaultPaymentMethodType === 'SEPA'">
      {{
        $t('paymentMethods.paymentMethod.SEPA', {
          mask: sepaAccountNumberMask,
          account: sepaAccountName,
        })
      }}
    </div>
    <div v-else-if="defaultPaymentMethodType === 'PAYPAL'">
      <img
          v-if="paypalLogo"
          :src="paypalLogo"
          alt="Paypal logo"
          height="24"
          width="38"
          class="shadow-[0_0_1px_0_rgba(41,52,58,0.75)] tw:mr-2 tw:inline"
      />
      PayPal - {{ paypalEmail }}
    </div>
    <div v-else>-</div>
  </div>
</template>

<script setup>
import { computed } from 'vue'

import { selectedAccommodationId } from '@/layouts/queries'
import { useExistingPaymentMethods } from '@/components/payment/queries'

const { defaultPaymentMethod, isError, isFetching } = useExistingPaymentMethods(selectedAccommodationId)

const sepaAccountName = computed(() => defaultPaymentMethod?.value?.accountHolderInfo?.accountHolderName)
const sepaAccountNumberMask = computed(() => defaultPaymentMethod?.value?.accountNumber)
const paypalEmail = computed(() => defaultPaymentMethod?.value?.email)
const creditCardHolderName = computed(() => defaultPaymentMethod?.value?.accountHolderInfo?.accountHolderName)
const creditCardNumberMask = computed(() => defaultPaymentMethod?.value?.cardNumber)
const creditCardExpirationMonth = computed(() => defaultPaymentMethod?.value?.expirationMonth)
const creditCardExpirationYear = computed(() => defaultPaymentMethod?.value?.expirationYear)

const paypalLogo = new URL('/src/assets/img/settings-payment/paypal.png', import.meta.url)
const visaLogo = new URL('/src/assets/img/settings-payment/visa.png', import.meta.url)
const mastercardLogo = new URL('/src/assets/img/settings-payment/mastercard.png', import.meta.url)
const americanexpressLogo = new URL('/src/assets/img/settings-payment/americanexpress.png', import.meta.url)
const creditCardLogo = computed(() => {
  const creditCardBrand = defaultPaymentMethod?.value?.creditCardType.toLowerCase?.()
  if (creditCardBrand === 'visa') return visaLogo
  if (creditCardBrand === 'mastercard') return mastercardLogo
  if (creditCardBrand === 'americanexpress') return americanexpressLogo
  return null
})

const defaultPaymentMethodType = computed(() => {
  if (creditCardNumberMask?.value) return 'CREDIT_CARD'
  if (sepaAccountNumberMask?.value) return 'SEPA'
  if (paypalEmail?.value) return 'PAYPAL'
  return null
})
</script>
